import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {UploadService} from '../../services/upload.service';
import {AppConfig} from "../../app.config";

@Component({
  selector: 'app-select-images',
  templateUrl: './select-images.component.html',
  styleUrls: ['./select-images.component.scss']
})
export class SelectImagesComponent implements OnInit, OnChanges {

  @Input() public src = [];
  @Output() upload: EventEmitter<string> = new EventEmitter();
  @Input() public checkedImgs = [];
  @Input() public overLimit;

  @ViewChild('file', {static: false}) public file: ElementRef;
  public images: Array<any> = [];
  public isError = false;

  constructor(
    private service: UploadService,
    private config: AppConfig
  ) {
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.src && this.src.length > 0) {
      this.images = this.src.map(s => `${this.config.getHost()}/api2/public/image?image_id=${s.id}&dimension=250`);
    } else {
      this.src = [];
    }
  }

  checkItem(id) {

    const indexOfReport = this.checkedImgs.indexOf(id);
    if ( indexOfReport == -1 ) {
      this.checkedImgs.push(id);
    }
    else {
      this.checkedImgs.splice(indexOfReport, 1);
      if ( this.overLimit ) this.overLimit = false;
    }
  }
}

